export default __webpack_public_path__ + "static/media/spark.26df206f.png";